import React, { useState, useEffect } from 'react';
import Header from '../../Components/Header/header';
import './claimrequeststatus.css';

const steps = [
    { key: "submitted", label: "Submitted" },
    { key: "sent", label: "Sent" },
    { key: "decision", label: "" }
];

const ClaimStatusScreen = () => {
    const [claims, setClaims] = useState([]);
    const [search, setSearch] = useState('');
    const [trackedClaimId, setTrackedClaimId] = useState(null);

    const orgId = localStorage.getItem("org_id");  // or from login API

   const fetchClaims = async () => {

    try {

        const response = await fetch(
            `/api/ebclaim_request?org_id=${orgId}`
        );

        const data = await response.json();

        const mappedData = data.map(c => ({
            claim_req_id: c.claim_req_id,
            emp_id: c.emp_id,
            emp_name: c.emp_name,
            patient_name: c.patient_name,
            claim_type: c.claim_type,
            hospital_name: c.hospital_name,
            sum_insured_bal: c.sum_insured_bal,
            claim_amount: c.claim_amount,
            doc_fath_loc: c.doc_fath_loc,
            claim_status: c.claim_status || "Pending"
        }));

        setClaims(mappedData);

    } catch (error) {

        console.error("Error fetching claims:", error);

    }

};


useEffect(() => {
    fetchClaims();
}, []);


/* ================= SEARCH ================= */

const filtered = claims.filter(claim =>
    claim.emp_name?.toLowerCase().includes(search.toLowerCase()) ||
    claim.emp_id?.toLowerCase().includes(search.toLowerCase())
);


/* ================= CLAIM APPROVE / REJECT ================= */

const handleClaimStatus = async (claimId, status) => {

    try {

        const res = await fetch(
            "/api/update-claim-status",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    claimId,
                    status
                })
            }
        );

        const data = await res.json();

        alert(data.message);

        fetchClaims(); // refresh table without reload

    } catch (error) {

        console.error(error);
        alert("Error updating claim status");

    }

};

    const getStepColor = (claim, stepKey) => {
        const status = claim.claim_status;
        switch (stepKey) {
            case 'submitted':
            case 'sent':
                return 'green';
            case 'review':
            case 'final':
                return status === 'Pending' ? 'gray' : status === 'Approved' ? 'green' : 'gray';
            default:
                return 'gray';
        }
    };

  
    return (
        <div className="claimstatus">
            <aside className="sidebar">
                <Header />
            </aside>

            <div className="claimstatus-card">
                <div className="claimstatus-header">
                    <h2 className="claimstatus-title">Claim Request Status</h2>
                    <button
                        className="claimstatus-btn"
                        onClick={() => (window.location.href = "/claimRequest")}
                    >
                        + New Claim Request
                    </button>
                </div>

                <div className="claimstatus-table-container">
                    <table className="claimstatus-table">
                        <thead>
                            <tr>
                                <th>Claim ID</th>
                                <th>Emp ID</th>
                                <th>Employee</th>
                                <th>Patient</th>
                                <th>Type</th>
                                <th>Hospital</th>
                                <th>Sum Insured balance</th>
                                <th>Claim Amount</th>
                                <th>Documents</th>
                                <th>Status</th>
                                <th>Track</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((claim) => (
                                <React.Fragment key={claim.claim_req_id}>
                                    <tr>
                                        <td>{claim.claim_req_id}</td>
                                        <td>{claim.emp_id}</td>
                                        <td>{claim.emp_name}</td>
                                        <td>{claim.patient_name || "-"}</td>
                                        <td>{claim.claim_type}</td>
                                        <td>{claim.hospital_name}</td>
                                        <td>{claim.sum_insured_bal}</td>
                                        <td>₹{claim.claim_amount}</td>
                                        <td>
                                            {claim.doc_fath_loc ? (
                                                <a
                                                    href={`/uploads/${claim.doc_fath_loc}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    View
                                                </a>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                        <td>{claim.claim_status}</td>
                                        <td>
                                            <button
                                                className="claimstatus-track-btn"
                                                onClick={() =>
                                                    setTrackedClaimId(
                                                        trackedClaimId === claim.claim_req_id
                                                            ? null
                                                            : claim.claim_req_id
                                                    )
                                                }
                                            >
                                                Track
                                            </button>
                                        </td>
                                    </tr>

                                  {trackedClaimId === claim.claim_req_id && (
<tr>
<td colSpan="10">

<div className="claim-tracker">

{/* Submitted */}
<div className="claim-step">
<div className="claim-circle active"></div>
<div className="claim-label">Submitted</div>
</div>

<div className="claim-line active"></div>

{/* Sent */}
<div className="claim-step">
<div className="claim-circle active"></div>
<div className="claim-label">Sent</div>
</div>

{/* Decision Step */}
{claim.claim_status && (
<>
<div className="claim-line active"></div>

<div className="claim-step">
<div
className="claim-circle"
style={{
backgroundColor:
claim.claim_status === "Approved"
? "green"
: "red"
}}
></div>

<div className="claim-label">
{claim.claim_status}
</div>
</div>
</>
)}

</div>

<div className="claim-btn-container">

<button
className="claim-approved-btn"
disabled={claim.claim_status === "Approved" || claim.claim_status === "Rejected"}
onClick={() => handleClaimStatus(claim.claim_req_id, "Approved")}
>
Approved
</button>

<button
className="claim-rejected-btn"
disabled={claim.claim_status === "Approved" || claim.claim_status === "Rejected"}
onClick={() => handleClaimStatus(claim.claim_req_id, "Rejected")}
>
Rejected
</button>

</div>

</td>
</tr>
)}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

);

};

export default ClaimStatusScreen;
